import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import cx from 'classnames';
import React, { useState } from 'react';
import Icon from './Icon';

var Avatar = function Avatar(_ref) {
  var className = _ref.className,
      image = _ref.image,
      name = _ref.name,
      size = _ref.size,
      opts = _objectWithoutPropertiesLoose(_ref, ["className", "image", "name", "size"]);

  var _useState = useState(false),
      error = _useState[0],
      setError = _useState[1];

  var nameProp = name ? name.trim() : '';
  var classes = cx('avatar', className, {
    'avatar--large': size === 'large'
  });
  var styles = {
    backgroundImage: "url(" + image + ")"
  }; // If image exists, use image for background

  if (image && !error) {
    return React.createElement("figure", Object.assign({
      className: classes,
      style: styles
    }, opts), React.createElement("img", {
      alt: nameProp,
      onError: function onError() {
        return setError(true);
      },
      className: "u-hidden",
      src: image
    }));
  } // If no image and no name, use icon


  if (!image && !nameProp) {
    return React.createElement("figure", Object.assign({
      className: classes
    }, opts), React.createElement(Icon, {
      className: "avatar-icon",
      icon: "user"
    }));
  }

  var splitName = null;
  var initials = null;

  if (nameProp) {
    splitName = name.split(' ');
    initials = splitName[0][0] + splitName[splitName.length - 1][0];
  } // https://stackoverflow.com/a/48841447/1026742
  // For text alignment


  return React.createElement("svg", Object.assign({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    className: classes
  }, opts), React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "50"
  }), React.createElement("text", {
    x: "50",
    y: "50",
    textAnchor: "middle",
    dy: "0.35em",
    fontSize: "40"
  }, initials));
};

Avatar.defaultProps = {
  size: 'default'
};
export default Avatar;